<style lang="scss" scoped>
// 默认
.izt-level-container {
  flex-shrink: 0;
  height: 58px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  &.medium, &.small {
    width: fit-content;
  }
  .levelicon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    [class*="icon-"] {
      font-size: 28px!important;
    }
  }
  .level-text {
    margin: 0 8px;
    color: rgba(0, 0, 0, 0.65);
    flex: 1;
  }
  &.active {
    background: var(--izt-card-color);
    .level-text {
      color: var(--izt-mirror-color-65);
    }
  }
}
// 小号
.izt-level-container.small {
  height: 30px;
  line-height: 30px;
  box-sizing: border-box;
  padding: 5px!important;
  border-radius: 8px!important;
  .levelicon {
    width: 20px;
    height: 20px;
    background: transparent!important;
    [class*="icon-"] {
      font-size: 20px!important;
    }
  }
  .level-text {
    font-weight: 400;
    font-size: 22px;
    color: rgba(0,0,0,0.65);
    text-align: left;
    font-style: normal;
    margin: 0 3px;
  }
}
// 大号
.izt-level-container.large {
  width: 100%!important;
  height: 64px;
  line-height: 64px;
  padding: 0 24px!important;
  border-radius: 18px!important;
  .levelicon {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    [class*="icon-"] {
      font-size: 28px!important;
    }
  }
  .level-text {
    font-weight: 400;
    font-size: 24px;
    margin: 0 16px;
  }
}
</style>

<template>
  <div :class="['izt-level-container', active && 'active', size, className]" :style="{background: size == 'small' && levelEnum[level]?.bgColor }" @click.stop="emit('click', level)">
    <div class="levelicon" :style="{background: levelEnum[level]?.bgColor}">
      <izt-icon class-name="icon-shoucang-xuanzhong" :fill="levelEnum[level]?.color"/>
    </div>
    <span class="level-text">{{text || levelEnum[level]?.text }}</span>
  </div>
</template>

<script setup name="izt-level">
  import { computed, ref, watch } from 'vue'
  import { levelEnum } from '@/utils/enumeration'
  defineOptions({ name: 'izt-level' })
  defineProps({
    className: { type: String, default: '' }, // 样式类名
    level: { type: [Number, String], default: 1 },
    active: { type: Boolean, default: false },
    size: { type: String, default: 'medium' }, // small(小) | medium(正常) | large(大)
    color: { type: String, default: null },
    text: { type: String, default: null },
  })
  const emit = defineEmits(['click'])
</script>